<div class="p-3 custom-table w-100">
  <div class="d-flex justify-content-between align-items-center pb-3">
    <div class="d-flex gap-2 align-items-center">
      <div class="mb-1" [innerHtml]="ICONS.BACK_ARROW('var(--gray-light-4)', 24, 24)" (click)="onBack()"></div>
      <div class="custom-header-text mb-1">{{ pageTitle }}</div>
    </div>
    <div class="d-flex justify-content-end">
      <button class="btn-md-filled-primary fw-bold" matRipple (click)="onOpenPopup()">
        <mat-icon class="text-white fs-20 mt-1">add_circle_outlined</mat-icon>
        Add
      </button>
    </div>
  </div>
  <div class="common-table-container">
    <div class="dynamic-list">
      <Table class="dynamic-table width-100">
        <thead class="h-40">
          <tr class="border-bottom-one border-light-4-gray fs-12 cursor-pointer">
            @for (item of tableColumns; track $index) {
              <th [width]="item.width + '%'" class="px-1">
                <div class="text-dark-4-gray d-flex align-items-center justify-content-{{ item.headerAlign }} fs-14 {{ item.customHeaderClass }}">
                  <span class="fw">{{ item.title }}</span>
                </div>
              </th>
            }
          </tr>
        </thead>
        <tbody>
          @for (item of dataSource; track $index) {
            <tr tabindex="1" class="border-bottom-one border-light-4-gray fs-12 align-items-center h-40 cursor-pointer task-item" [ngClass]="{ active: item.isActive }">
              @for (column of tableColumns; track $index) {
                <td class="p-2" [width]="column.width + '%'">
                  <mobi-office-table-columns-view [item]="item" [column]="column"></mobi-office-table-columns-view>
                </td>
              }
            </tr>
          }
        </tbody>
      </Table>
    </div>
  </div>
</div>

<ng-template #AddTeamMemberTemplate>
  <div class="customer-popover-container">
    <div class="bg-light-2-primary pt-2 pb-2 pe-3 ps-3 d-flex justify-content-between align-items-center">
      <div class="title fw-bold fs-18">{{ teamEdit ? "Edit" : "Add" }} Team Member</div>

      <mat-icon (click)="onClose()">close</mat-icon>
    </div>
    <div class="bg-light-1-primary pt-2 pb-2 pe-3 ps-3" mat-dialog-content>
      <div class="row">
        <div class="col-12 mt-2">
          <mobi-office-lib-input-field [(model)]="team.Name" label="Name" placeholder="Enter Name" [isRequired]="true"></mobi-office-lib-input-field>
        </div>

        <div class="col-12 mt-2">
          <label class="fs-14 mb-1" Asterisk>Phone Number</label>
          <mobi-office-int-tel-input [(model)]="team.numberField"></mobi-office-int-tel-input>
        </div>
        <div class="col-12 mt-2">
          <mobi-office-lib-drop-down
            label="Role"
            class="width-full"
            [optionList]="roleList"
            bindValue="RID"
            [(model)]="team.Role"
            [multiple]="true"
            bindLabel="Name"
            placeholder="Select Role"
            [hideSelected]="true"
            [isRequired]="true">
          </mobi-office-lib-drop-down>
        </div>
        @if (teamEdit) {
          <div class="col-12 mt-2">
            <mat-checkbox class="text-primary" [(ngModel)]="team.IsActive"> IsActive</mat-checkbox>
          </div>
        }
      </div>
      <div class="actions w-100 mt-2">
        <button class="btn-md-filled-primary fw-bold w-100 justify-center" matRipple (click)="teamEdit ? onEditTeamMember() : onAddTeamMember()">
          <mat-icon class="text-white fs-20 mt-2">add_circle_outlined</mat-icon>
          {{ teamEdit ? "Edit member" : "Add member" }}
        </button>
      </div>
    </div>
  </div>
</ng-template>
